
import {createContext, useRef} from 'react';

export const InputContext = createContext('');